module.exports = __webpack_public_path__ + "img/simulacao.c073646c.png";